(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-collection]').forEach((root)=>{
    requestAnimationFrame(()=>root.querySelector('.pd-collection__hero')?.classList.add('is-visible'));
    const teamInput=root.querySelector('[data-pd-team-search]'),teamTrack=root.querySelector('[data-pd-team-track]');
    if(teamInput&&teamTrack){const teams=[...teamTrack.querySelectorAll('[data-pd-team]')],count=root.querySelector('[data-pd-team-count]'),empty=root.querySelector('[data-pd-team-empty]');const filterTeams=()=>{const q=teamInput.value.trim().toLowerCase();let visible=0;teams.forEach(team=>{team.hidden=!team.dataset.pdTeamName.includes(q);if(!team.hidden)visible++});count.textContent=visible;empty.hidden=visible>0};teamInput.addEventListener('input',filterTeams);root.querySelector('[data-pd-team-prev]')?.addEventListener('click',()=>teamTrack.scrollBy({left:-420,behavior:'smooth'}));root.querySelector('[data-pd-team-next]')?.addEventListener('click',()=>teamTrack.scrollBy({left:420,behavior:'smooth'}))}
    const retro=root.querySelector('[data-pd-retro]');
    if(retro){let active='clubs';const viewport=retro.querySelector('[data-pd-retro-viewport]'),search=root.querySelector('[data-pd-retro-search]'),clear=root.querySelector('[data-pd-retro-clear]');const currentPanel=()=>retro.querySelector(`[data-pd-retro-panel="${active}"]`);const filterRetro=()=>{const query=(search?.value||'').trim().toLowerCase();currentPanel()?.querySelectorAll('[data-pd-retro-team]').forEach(item=>item.hidden=query&&!item.dataset.pdRetroName.includes(query));if(clear)clear.style.opacity=query?'1':'';viewport.scrollTo({left:0,behavior:'instant'});const cards=[...root.querySelectorAll('[data-pd-title]')];let visible=0;cards.forEach(card=>{const hide=query&&!card.dataset.pdTitle.includes(query);card.hidden=hide;if(!hide)visible++});const visibleCount=root.querySelector('[data-pd-visible-count]'),productEmpty=root.querySelector('[data-pd-search-empty]');if(visibleCount)visibleCount.textContent=visible;if(productEmpty)productEmpty.hidden=visible>0};retro.querySelectorAll('[data-pd-retro-tab]').forEach(button=>button.addEventListener('click',()=>{active=button.dataset.pdRetroTab;retro.querySelectorAll('[data-pd-retro-tab]').forEach(tab=>{const selected=tab===button;tab.classList.toggle('is-active',selected);tab.setAttribute('aria-selected',selected?'true':'false')});retro.querySelectorAll('[data-pd-retro-panel]').forEach(panel=>panel.hidden=panel.dataset.pdRetroPanel!==active);if(search)search.value='';filterRetro()}));search?.addEventListener('input',filterRetro);clear?.addEventListener('click',()=>{search.value='';filterRetro();search.focus()});retro.querySelector('[data-pd-retro-prev]')?.addEventListener('click',()=>viewport.scrollBy({left:-520,behavior:'smooth'}));retro.querySelector('[data-pd-retro-next]')?.addEventListener('click',()=>viewport.scrollBy({left:520,behavior:'smooth'}))}
    const productInput=root.querySelector('[data-pd-product-search]'),grid=root.querySelector('[data-pd-product-grid]'),visibleCount=root.querySelector('[data-pd-visible-count]'),productEmpty=root.querySelector('[data-pd-search-empty]'),pagination=root.querySelector('.pd-pagination');
    const originalGrid=grid?grid.innerHTML:'';
    const originalCount=visibleCount?visibleCount.textContent:'';
    let searchTimer=0,searchId=0;
    const paintStoreSearch=(html,count,query)=>{
      if(!grid) return;
      if(!query){grid.innerHTML=originalGrid;if(visibleCount)visibleCount.textContent=originalCount;if(productEmpty)productEmpty.hidden=true;if(pagination)pagination.hidden=false;return}
      grid.innerHTML=html||'';
      if(visibleCount)visibleCount.textContent=String(count||0);
      if(productEmpty){productEmpty.hidden=count>0;productEmpty.textContent=count>0?'':'No encontramos camisetas con ese nombre.'}
      if(pagination)pagination.hidden=true;
    };
    const runStoreSearch=()=>{
      const query=(productInput?.value||'').trim();
      clearTimeout(searchTimer);
      if(query.length<2){paintStoreSearch('',0,'');return}
      searchTimer=setTimeout(async()=>{
        const id=++searchId;
        try{
          const response=await fetch('/search?q='+encodeURIComponent(query)+'&type=product&view=pd-json');
          const data=await response.json();
          if(id!==searchId) return;
          paintStoreSearch(data.html||'',data.count||0,query);
        }catch(error){
          if(id===searchId) window.location.href='/search?q='+encodeURIComponent(query)+'&type=product';
        }
      },280);
    };
    productInput?.addEventListener('input',runStoreSearch);
    root.querySelector('[data-pd-product-clear]')?.addEventListener('click',()=>{if(!productInput)return;productInput.value='';paintStoreSearch('',0,'');productInput.focus()});
    const filterToggle=root.querySelector('[data-pd-filter-toggle]');const setFilters=(open)=>{root.classList.toggle('is-filters-open',open);filterToggle?.setAttribute('aria-expanded',open?'true':'false');document.documentElement.style.overflow=open?'hidden':''};filterToggle?.addEventListener('click',()=>setFilters(true));root.querySelectorAll('[data-pd-filter-close]').forEach(button=>button.addEventListener('click',()=>setFilters(false)));document.addEventListener('keydown',event=>{if(event.key==='Escape')setFilters(false)});
    root.querySelectorAll('[data-pd-view]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-pd-view]').forEach(item=>item.classList.toggle('is-active',item===button));root.querySelector('[data-pd-product-grid]')?.classList.toggle('is-list',button.dataset.pdView==='list')}))
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-clubs]').forEach((root)=>{const viewport=root.querySelector('[data-pd-club-viewport]');const previous=root.querySelector('[data-pd-club-previous]');const next=root.querySelector('[data-pd-club-next]');const search=root.querySelector('[data-pd-club-search]');const clear=root.querySelector('[data-pd-club-search-clear]');let activeKey='leagues';const labels={leagues:'Buscar liga...',teams:'Buscar equipo...',retro:'Buscar club o país...'};const activePanel=()=>root.querySelector(`[data-pd-tab-panel="${activeKey}"]`);const update=()=>{const atStart=viewport.scrollLeft<=2;const atEnd=viewport.scrollLeft+viewport.clientWidth>=viewport.scrollWidth-2;previous.disabled=atStart;next.disabled=atEnd};const filter=()=>{const query=search.value.trim().toLocaleLowerCase('es');activePanel()?.querySelectorAll('a').forEach(card=>{card.hidden=query&&!card.textContent.toLocaleLowerCase('es').includes(query)});clear.hidden=!query;viewport.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update)};const scroll=(direction)=>viewport.scrollBy({left:direction*Math.max(240,viewport.clientWidth*.72),behavior:'smooth'});previous.addEventListener('click',()=>scroll(-1));next.addEventListener('click',()=>scroll(1));viewport.addEventListener('scroll',update,{passive:true});viewport.addEventListener('keydown',(event)=>{if(event.key==='ArrowLeft'){event.preventDefault();scroll(-1)}if(event.key==='ArrowRight'){event.preventDefault();scroll(1)}});search.addEventListener('input',filter);clear.addEventListener('click',()=>{search.value='';filter();search.focus()});root.querySelectorAll('[data-pd-tab]').forEach((button)=>button.addEventListener('click',()=>{activeKey=button.dataset.pdTab;root.querySelectorAll('[data-pd-tab]').forEach((item)=>{const active=item===button;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active?'true':'false')});root.querySelectorAll('[data-pd-tab-panel]').forEach((panel)=>{panel.hidden=panel.dataset.pdTabPanel!==activeKey;panel.querySelectorAll('a').forEach(card=>card.hidden=false)});search.value='';search.placeholder=labels[activeKey];clear.hidden=true;viewport.scrollTo({left:0,behavior:'instant'});requestAnimationFrame(update)}));window.addEventListener('resize',update,{passive:true});update()});
  document.querySelectorAll('[data-pd-feature-gallery]').forEach((gallery)=>{const slides=[...gallery.querySelectorAll('[data-pd-feature-slide]')];const thumbs=[...gallery.querySelectorAll('[data-pd-feature-thumb]')];const nav=gallery.querySelectorAll('.pd-home__feature-nav');if(slides.length<2){nav.forEach((button)=>button.hidden=true);if(thumbs.length)gallery.querySelector('.pd-home__feature-thumbs')?.setAttribute('hidden','');return}let index=Math.max(0,slides.findIndex((slide)=>slide.classList.contains('is-active')));const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===index))};gallery.querySelector('[data-pd-feature-prev]')?.addEventListener('click',()=>show(index-1));gallery.querySelector('[data-pd-feature-next]')?.addEventListener('click',()=>show(index+1));thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)))});
  document.querySelectorAll('[data-pd-feature-countdown]').forEach((el)=>{const boxes=el.querySelectorAll('strong');const tick=()=>{const end=new Date();end.setHours(24,0,0,0);const ms=Math.max(0,end-Date.now());const parts=[Math.floor(ms/86400000),Math.floor(ms/3600000)%24,Math.floor(ms/60000)%60];boxes.forEach((box,i)=>{if(box.firstChild)box.firstChild.textContent=String(parts[i]).padStart(2,'0')})};tick();setInterval(tick,1000)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-nations"]) return;
  try {
    
  document.querySelectorAll('[data-pd-nations]').forEach((root)=>{
    const input=root.querySelector('[data-pd-nations-search]');
    const clear=root.querySelector('[data-pd-nations-clear]');
    const empty=root.querySelector('[data-pd-nations-empty]');
    const cards=[...root.querySelectorAll('[data-pd-nations-card]')];
    const filter=()=>{
      const q=(input?.value||'').trim().toLowerCase();
      let visible=0;
      cards.forEach((card)=>{
        const match=!q||(card.dataset.pdNationsName||'').includes(q);
        card.hidden=!match;
        if(match) visible+=1;
      });
      if(empty) empty.hidden=visible>0;
    };
    input?.addEventListener('input',filter);
    clear?.addEventListener('click',()=>{if(input)input.value='';filter();input?.focus()});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-product]').forEach((root)=>{
    if(root.dataset.pdBound==='true') return;
    root.dataset.pdBound='true';
    const variants=JSON.parse(root.querySelector('[data-pd-variants]').textContent);
    const form=root.querySelector('[data-pd-product-form]');
    const input=root.querySelector('[data-pd-variant-id]');
    const feedback=root.querySelector('[data-pd-feedback]');
    const add=root.querySelector('[data-pd-add]');
    const sizePos=Number(root.dataset.pdSizeOption||0)-1;
    const customCents=Number(root.dataset.pdCustomCents||0);
    const customId=Number(root.dataset.pdCustomId||0);
    const patchCents=Number(root.dataset.pdPatchCents||0);
    const patchId=Number(root.dataset.pdPatchId||45594181632176);
    const money=(cents)=>new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(Number(cents||0)/100);
    const patchesOn=()=>Boolean(root.querySelector('[data-pd-patches-toggle]')?.checked);
    const selectedPatches=()=>[...root.querySelectorAll('[data-pd-patch-choice]:checked')].map((choice)=>choice.dataset.pdPatchName).filter(Boolean);
    const selections=(variants[0]?.options||[]).slice();
    if(sizePos>=0) selections[sizePos]='';
    let customName='', customNumber='', adding=false;
    const openCart=()=>{if(window.pdOpenCart){window.pdOpenCart();return}const drawer=document.querySelector('[data-pd-cart]');if(drawer){drawer.hidden=false;document.documentElement.style.overflow='hidden'}};
    const sizeReady=()=>sizePos<0||Boolean(selections[sizePos]);
    const findVariant=(requireSize)=>variants.find((item)=>item.options.every((value,index)=>{
      if(index===sizePos){
        if(requireSize) return value===selections[sizePos];
        return !selections[sizePos]||value===selections[sizePos];
      }
      return value===selections[index];
    }));
    const findPriceVariant=()=>{
      if(sizeReady()) return findVariant(true);
      return variants.find((item)=>item.options.every((value,index)=>index===sizePos||value===selections[index]));
    };
    function render(){
      root.querySelectorAll('[data-pd-option]').forEach((button)=>{
        const position=Number(button.dataset.pdOption)-1;
        button.classList.toggle('is-selected',selections[position]===button.dataset.pdValue);
      });
      const priceVariant=findPriceVariant();
      const variant=sizeReady()?findVariant(true):null;
      const ready=sizeReady();
      if(variant) input.value=variant.id;
      else if(priceVariant&&ready===false) input.value=priceVariant.id;
      const base=Number(priceVariant?.price||variants[0]?.price||0);
      const extra=((customName||customNumber)?customCents:0)+(patchesOn()?patchCents:0);
      const total=money(base+extra);
      let html='<strong>'+total+'</strong>';
      if(priceVariant?.compare_at_price>priceVariant?.price){
        const pct=Math.round((Number(priceVariant.compare_at_price)-Number(priceVariant.price))*100/Number(priceVariant.compare_at_price));
        html+='<s>'+money(priceVariant.compare_at_price)+'</s><em>Ahorra '+pct+'%</em>';
      }
      root.querySelectorAll('[data-pd-price]').forEach((priceNode)=>{priceNode.innerHTML=html});
      root.querySelectorAll('[data-pd-price-dock]').forEach((priceNode)=>{
        if(priceNode.closest('.pd-product__dock')) priceNode.innerHTML='<small>Total</small><strong>'+total+'</strong>';
        else priceNode.textContent=total;
      });
      if(!ready){
        add.disabled=true;
        add.textContent='Selecciona talla';
        feedback.textContent='';
        return;
      }
      if(!variant){
        add.disabled=true;
        add.textContent='No disponible';
        feedback.textContent='Esta combinación no está disponible.';
        return;
      }
      add.disabled=!variant.available;
      add.textContent=variant.available?'Agregar a la bolsa':'Agotado';
      feedback.textContent='';
    }
    root.querySelectorAll('[data-pd-option]').forEach((button)=>button.addEventListener('click',()=>{
      selections[Number(button.dataset.pdOption)-1]=button.dataset.pdValue;
      render();
    }));
    const gallery=root.querySelector('[data-pd-gallery]');
    if(gallery){
      const slides=[...gallery.querySelectorAll('[data-pd-media]')];
      const pager=gallery.querySelector('[data-pd-pager]');
      let index=0;
      const thumbs=[...gallery.querySelectorAll('[data-pd-thumb]')];
      const show=(next)=>{if(!slides.length)return;index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));thumbs.forEach((thumb,i)=>thumb.classList.toggle('is-active',i===index));if(pager)pager.textContent=String(index+1)};
      gallery.querySelector('[data-pd-gallery-prev]')?.addEventListener('click',()=>show(index-1));
      gallery.querySelector('[data-pd-gallery-next]')?.addEventListener('click',()=>show(index+1));
      thumbs.forEach((thumb)=>thumb.addEventListener('click',()=>show(Number(thumb.dataset.pdThumb))));
    }
    const patchToggle=root.querySelector('[data-pd-patches-toggle]');
    const patchChoices=root.querySelector('[data-pd-patch-choices]');
    const syncPatches=()=>{
      const enabled=patchesOn();
      patchChoices?.classList.toggle('is-locked',!enabled);
      if(!enabled) root.querySelectorAll('[data-pd-patch-choice]').forEach((input)=>{input.checked=false});
      render();
    };
    patchToggle?.addEventListener('change',syncPatches);
    const customizeModal=root.querySelector('[data-pd-customize-modal]');
    const guideModal=root.querySelector('[data-pd-guide-modal]');
    const nameInput=root.querySelector('[data-pd-customize-name]');
    const numberInput=root.querySelector('[data-pd-customize-number]');
    const summary=root.querySelector('[data-pd-custom-summary]');
    const applyCustom=()=>{
      customName=(nameInput?.value||'').trim().toUpperCase();
      customNumber=(numberInput?.value||'').trim();
      const nameField=root.querySelector('[data-pd-name]');
      const numberField=root.querySelector('[data-pd-number]');
      if(nameField) nameField.value=customName;
      if(numberField) numberField.value=customNumber;
      if(summary){
        summary.hidden=!(customName||customNumber);
        summary.textContent=(customName||customNumber)?(customName+(customNumber?' · #'+customNumber:'')):'';
      }
      render();
    };
    nameInput?.addEventListener('input',applyCustom);
    numberInput?.addEventListener('input',applyCustom);
    root.querySelector('[data-pd-customize-open]')?.addEventListener('click',()=>{customizeModal.hidden=false;document.documentElement.style.overflow='hidden';applyCustom()});
    root.querySelector('[data-pd-customize-close]')?.addEventListener('click',()=>{customizeModal.hidden=true;document.documentElement.style.overflow=''});
    root.querySelector('[data-pd-customize-save]')?.addEventListener('click',()=>{applyCustom();customizeModal.hidden=true;document.documentElement.style.overflow=''});
    root.querySelector('[data-pd-size-guide]')?.addEventListener('click',()=>{guideModal.hidden=false;document.documentElement.style.overflow='hidden'});
    root.querySelector('[data-pd-guide-close]')?.addEventListener('click',()=>{guideModal.hidden=true;document.documentElement.style.overflow=''});
    customizeModal?.addEventListener('click',(event)=>{if(event.target===customizeModal){customizeModal.hidden=true;document.documentElement.style.overflow=''}});
    guideModal?.addEventListener('click',(event)=>{if(event.target===guideModal){guideModal.hidden=true;document.documentElement.style.overflow=''}});
    root.querySelectorAll('[data-pd-policy-tab]').forEach((button)=>button.addEventListener('click',()=>{
      root.querySelectorAll('[data-pd-policy-tab]').forEach((tab)=>tab.classList.toggle('is-active',tab===button));
      root.querySelectorAll('[data-pd-policy-panel]').forEach((panel)=>panel.hidden=panel.dataset.pdPolicyPanel!==button.dataset.pdPolicyTab);
    }));
    root.querySelectorAll('[data-pd-accordion]').forEach((accordion)=>{
      const trigger=accordion.querySelector('[data-pd-accordion-trigger]');
      const panel=accordion.querySelector('[data-pd-accordion-panel]');
      trigger?.addEventListener('click',()=>{
        const open=trigger.getAttribute('aria-expanded')==='true';
        trigger.setAttribute('aria-expanded',open?'false':'true');
        accordion.classList.toggle('is-open',!open);
        if(panel) panel.hidden=open;
      });
    });
    const addConfiguredJersey=async()=>{
      if(adding||window.pdAddLock||!sizeReady()||add.disabled) return;
      adding=true;
      window.pdAddLock=true;
      add.disabled=true;
      feedback.textContent='Agregando…';
      try{
        applyCustom();
        const variantId=Number(input.value);
        if(!variantId) throw new Error('variant');
        const productId=Number(root.dataset.pdProductId||0);
        const title=root.dataset.pdTitle||'';
        const current=await fetch('/cart.js').then((res)=>res.json());
        const updates={};
        (current.items||[]).forEach((item)=>{
          const addon=window.pdIsCartAddon?.(item)||item.properties?._Addon;
          const sameProduct=Number(item.product_id)===productId||item.product_title===title;
          const linked=addon&&(item.properties?._Para===title||sameProduct);
          if(sameProduct||linked) updates[item.key]=0;
        });
        if(Object.keys(updates).length){
          await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
        }
        const wantCustom=Boolean(customName||customNumber);
        const wantPatches=patchesOn();
        const patchNames=selectedPatches();
        const bundle='pd'+Date.now().toString(36);
        const properties={_Bundle:bundle};
        if(customName) properties['Nombre']=customName;
        if(customNumber) properties['Número']=customNumber;
        if(wantCustom) properties['Personalización']='+ '+money(customCents);
        if(wantPatches) properties['Parches']=patchNames.join(', ')||'Parches';
        const extraUnits=(wantCustom?2:0)+(wantPatches?1:0);
        const extras=(extraUnits&&patchId)?[{id:patchId,quantity:extraUnits,properties:{_Bundle:bundle,_Addon:'1',_Units:String(extraUnits),_Para:title}}]:[];
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1,properties},...extras]})});
        if(!response.ok) throw new Error('add');
        const cart=await fetch('/cart.js').then((res)=>res.json());
        window.pdRenderCartDrawer?.(cart);
        feedback.textContent='Listo: ya está en tu bolsa.';
        openCart();
      }catch(error){
        feedback.textContent='No fue posible agregarla. Intenta de nuevo.';
      }finally{
        adding=false;
        window.pdAddLock=false;
        add.disabled=false;
        render();
      }
    };
    add?.addEventListener('click',(event)=>{event.preventDefault();event.stopPropagation();addConfiguredJersey();});
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-recommended"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event)=>{
    const prev=event.target.closest('[data-pd-rec-prev]');
    const next=event.target.closest('[data-pd-rec-next]');
    if(!prev && !next) return;
    const track=event.target.closest('[data-pd-recommended]')?.querySelector('[data-pd-rec-track]');
    if(!track) return;
    track.scrollBy({left: next ? Math.max(280, track.clientWidth * .7) : -Math.max(280, track.clientWidth * .7), behavior:'smooth'});
  });
  const loadRecommended=(root)=>{
    if(!root || root.dataset.performed==='true' || !root.dataset.url || root.dataset.loading==='true') return;
    root.dataset.loading='true';
    fetch(root.dataset.url).then((response)=>response.text()).then((html)=>{
      const doc=new DOMParser().parseFromString(html,'text/html');
      const next=doc.querySelector('[data-pd-recommended]');
      if(next && next.querySelector('.pd-recommended__track')) root.replaceWith(next);
    }).catch(()=>{}).finally(()=>{ if(root.isConnected) root.dataset.loading='false'; });
  };
  const watchRecommended=()=>{
    document.querySelectorAll('[data-pd-recommended]').forEach((root)=>{
      if(root.dataset.watched==='true') return;
      root.dataset.watched='true';
      const observer=new IntersectionObserver((entries)=>{
        if(!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommended(root);
      },{rootMargin:'0px 0px 240px 0px'});
      observer.observe(root);
    });
  };
  watchRecommended();
  document.addEventListener('shopify:section:load', watchRecommended);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-search"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-search]').forEach((root)=>{
    const input=root.querySelector('input[type="search"]');
    root.querySelector('[data-pd-search-clear]')?.addEventListener('click',()=>{if(!input)return;input.value='';input.form?.submit();});
  });

  } catch(e) { console.error(e); }
})();
})();
